<template>
  <div>
    <!-- 添加 -->
    <el-button type="primary" @click="onAddBooks" v-if="isadmin">添加</el-button>
    <!-- table  -->
    <el-table :data="usersData" style="width: 100%" class="bottom">
      <el-table-column type="index" label="序号" :index="indexMethod">
      </el-table-column>
      <el-table-column prop="userName" label="姓名"> </el-table-column>
      <el-table-column prop="email" label="邮箱"> </el-table-column>
      <!-- 管理员有编辑，删除权限；管理员不能删除自己 -->
      <el-table-column label="操作"  v-if="isadmin">
        <template slot-scope="scope">
          <el-button type="text" @click="onEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button v-if="!scope.row.admin" type="text" @click="onDel(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      class="bottom"
      @current-change="onChangePage"
    >
    </el-pagination>
    <UserAdd
      v-model="isShowDrawer"
      :editForm="editForm"
      @on-update="onUpdate"
    ></UserAdd>
  </div>
</template>
<script>
// 引入组件
import UserAdd from "../users/user-add-edit";
// api
import { GetUserList, DelUser } from "../../api/user";
export default {
  components: { UserAdd },
  data() {
    return {
      usersData: [],
      total: 0,
      isShowDrawer: false,
      editForm: {},
      params: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    // false 普通用户， true 管理员；只有管理员才可以操作用户
    isadmin() {
      return true ? sessionStorage.getItem("admin") == "true" : false
    },
  },
  methods: {
    onChangePage(num) {
      this.params.pageNum = num;
      this.GetUserList();
    },
    indexMethod(index) {
      return (this.params.pageNum - 1) * this.params.pageSize + (index + 1);
    },
    // 添加
    onAddBooks() {
      this.isShowDrawer = true;
    },
    // 修改
    onEdit(index, row) {
      this.isShowDrawer = true;
      this.editForm = {
        userId: row.userId,
        userName: row.userName,
        email: row.email,
      };
    },
    onUpdate() {
      this.GetUserList();
    },
    // 删除
    onDel(index, row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelUser(row.userId).then((res) => {
            if (res.status) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              if (this.usersData.length == 1 && this.params.pageNum > 1) {
                this.params.pageNum--;
              }
              this.GetUserList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 获取列表
    GetUserList() {
      GetUserList(this.params).then((res) => {
        if (res.status) {
          this.usersData = res.data.dataList;
          this.total = res.data.total;
        }
      });
    },
  },
  mounted() {
    this.GetUserList();
  },
};
</script>
<style lang="less" scoped>
.bottom {
  margin-top: 20px;
}
</style>
